import { useCallback } from 'react';
import type AskAllTrailsQueryType from '@alltrails/amplitude/enums/AskAllTrailsQueryType';
import useAskLocation from '@/hooks/useAskLocation';
import useIsAskChatEnabled from '@/hooks/useIsAskChatEnabled';
import { useAppDispatch } from '@/utils/redux';
import { askQuestion } from '@/utils/slices/askSlice';

/**
 * Submits an Ask AllTrails question, as the chat's next turn when Ask is a chat, searching the part of the map the user can
 * see unless the question names a place.
 */
const useAskQuestion = () => {
  const dispatch = useAppDispatch();
  const getAskLocation = useAskLocation();
  const isChat = useIsAskChatEnabled();

  return useCallback(
    (question: string, queryType: AskAllTrailsQueryType) => {
      dispatch(askQuestion({ isChat, location: getAskLocation(), question, queryType }));
    },
    [dispatch, getAskLocation, isChat]
  );
};

export default useAskQuestion;
